import { getBundle } from '@nrk/nrkno-snowplow';
import { EntitySchema } from '@nrk/snowplow-web';
import { g as getHost } from './shared/dh-snowplow.1ee613bf.mjs';

const APP_ID = "no.nrk.dh";
function resolveOrTimeout(promise, wait) {
  return Promise.race([
    promise.then(() => true),
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(false);
      }, wait);
    })
  ]);
}
function createTracker(trackerId, { environment, contentContext }) {
  let trackerReady = false;
  let bundle;
  const host = getHost(environment);
  const eventQueue = [];
  const contexts = ["service", "user"];
  const trackOrQueue = (callback) => {
    if (trackerReady) {
      callback(bundle);
    } else {
      eventQueue.push(callback);
    }
  };
  const trackStructuredEvent = (event) => trackOrQueue(({ NrknoUtils, Snowplow }) => {
    Snowplow.trackStructEvent(
      {
        ...event,
        context: NrknoUtils.context.collect(contexts)
      },
      [trackerId]
    );
  });
  const trackSelfDescribingEvent = (event) => trackOrQueue(
    ({ NrknoUtils, Snowplow }) => Snowplow.trackSelfDescribingEvent(
      {
        event,
        context: NrknoUtils.context.collect(contexts)
      },
      [trackerId]
    )
  );
  getBundle((nrknoBundle) => {
    bundle = nrknoBundle;
    const { NrknoUtils } = nrknoBundle;
    NrknoUtils.newTracker(trackerId, APP_ID, host);
    if (contentContext) {
      const contentContextId = `${trackerId}-${contentContext.id}`;
      contexts.push(contentContextId);
      NrknoUtils.context.set(contentContextId, EntitySchema.Content, {
        source: contentContext.source,
        id: contentContext.id
      });
    }
    resolveOrTimeout(NrknoUtils.trackers.whenReady("main-tracker"), 1e3).then((isResolved) => {
      trackerReady = true;
      if (isResolved === false) {
        console.warn("nrkno tracker not available");
      }
      while (eventQueue.length) {
        const fn = eventQueue.pop();
        fn(bundle);
      }
      return;
    }).catch(console.error);
  });
  return {
    trackSelfDescribingEvent,
    trackStructuredEvent
  };
}

export { createTracker, getHost };
